import React, { useEffect } from 'react';
import MasterDetailLayout from 'src/components/10-atoms/layout/MasterDetailLayout';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useListViewMode, { isQuestionListMasterDetail, } from 'src/hooks/useListViewMode';
import QuestionDetailPane from './QuestionDetailPane';
import QuestionListItems from './QuestionListItems';
import useQuestionListSelection from './useQuestionListSelection';
function QuestionList({ onQuestionPress, getQuestionTo, variant, ListEmptyComponent, selectedQuestionID, onSelectedQuestionIDChange, queryState, ...paginatedListProps }) {
    const [{ deviceType }] = useTheme();
    const { listViewMode } = useListViewMode();
    const isMasterDetail = isQuestionListMasterDetail(deviceType.isDesktop, listViewMode);
    const items = queryState.data?.list;
    useEffect(() => {
        if (!isMasterDetail &&
            onSelectedQuestionIDChange &&
            selectedQuestionID) {
            onSelectedQuestionIDChange(undefined);
        }
    }, [isMasterDetail, onSelectedQuestionIDChange, selectedQuestionID]);
    const { selectedQuestion, selectedIndex, selectQuestion } = useQuestionListSelection({
        isMasterDetail,
        selectedQuestionID,
        onSelectedQuestionIDChange,
        items,
    });
    const handleItemPress = (item, index) => {
        if (isMasterDetail) {
            selectQuestion(item, index);
        }
        onQuestionPress?.(item, index);
    };
    const listPane = (React.createElement(QuestionListItems, { variant: variant, ListEmptyComponent: ListEmptyComponent, isMasterDetail: isMasterDetail, selectedQuestionID: selectedQuestion?.id, onItemPress: handleItemPress, getQuestionTo: getQuestionTo, queryState: queryState, ...paginatedListProps }));
    if (!isMasterDetail) {
        return listPane;
    }
    const showDetail = !!selectedQuestion;
    return (React.createElement(MasterDetailLayout, { showDetail: showDetail, listPane: listPane, detailPane: selectedQuestion ? (React.createElement(QuestionDetailPane, { key: selectedQuestion.id, question: selectedQuestion, selectedIndex: selectedIndex, getQuestionTo: getQuestionTo })) : undefined }));
}
export default QuestionList;
